import React from "react";
import { Grid, Card, CardContent } from "@material-ui/core";
import Header from "./styles-forms/Header";

import logo from "../../logoGestdoc.svg";

/* Misma estructura que la etapa de registro (#center-form + .gd-login): la versión
   anterior subía la tarjeta con margin-top -250px y tapaba el título del hero. */
export default function ProcedureError() {
  return (
    <>
      <div
        style={{
          height: "50px",
          backgroundColor: "#1d0c8e",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <img
            style={{
              height: "33px",
              padding: "30px",
              paddingLeft: "65px",
            }}
            src={logo}
            alt="Logo Gestdoc"
          />
        </div>
        <div></div>
      </div>
      <div style={{ backgroundColor: "#f1f4fb" }}>
        <Header documento={{ _category: "", _nameSchema: "Lo sentimos mucho :(" }} position={"center"} />
        <Grid id="center-form" container direction="row" justify="center" alignItems="center">
          <Grid item xl={4} md={6} className="gd-login-col">
            <Card className="mb-5 card-box card-box-border-bottom border-success justForm gd-login">
              <CardContent className="gd-login-content">
                <h2 className="gd-login-title">No pudimos continuar con tu trámite</h2>
                <p className="gd-login-sub">
                  Puede que el enlace no sea válido o que haya ocurrido un error. Vuelve a intentarlo en unos minutos.
                </p>
                {/* submit: .ContinueForm[type="button"] tiene el estilo secundario de "volver" */}
                <form
                  className="gd-login-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    window.location.reload();
                  }}
                >
                  <button type="submit" className="ContinueForm gd-login-primary">
                    Reintentar
                  </button>
                </form>
                <p className="gd-login-foot">
                  Si el problema sigue, escríbenos a{" "}
                  <a className="gd-login-link" href="mailto:soporte@resit.cl">
                    soporte@resit.cl
                  </a>
                </p>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
